import { isMobile } from 'react-device-detect'
import api from '../utils/api'

class CasinoService {
  getCasinoList() {
    return api.get('get-casino-games')
  }

  getLiveCasinoCatalog() {
    return api.get('casino/alllist')
  }

  getLiveCasinoRound(gtype: string) {
    return api.get(`casino/data?gtype=${encodeURIComponent(gtype)}`)
  }

  getLiveCasinoHistory(gtype: string) {
    return api.get(`casino/lastresultsnew?gType=${encodeURIComponent(gtype)}`)
  }

  getLiveCasinoBook(gtype: string, mid?: string | number) {
    return api.get(`casino/book?gType=${encodeURIComponent(gtype)}&mid=${mid || ''}`)
  }

  placeLiveCasinoBet(body: {
    gtype: string
    sid: number
    nat?: string
    stack: number
    isBack?: boolean
    mid?: string | number
  }) {
    return api.post('casino/bet', body)
  }

  getLiveCasinoStream(id: string) {
    return api.get(`casino_stream?id=${encodeURIComponent(id)}`)
  }

  getLiveCasinoDetail(gtype: string, mid: string | number) {
    return api.get(
      `casino/detail_casino_results?gtype=${encodeURIComponent(gtype)}&mid=${encodeURIComponent(
        String(mid),
      )}`,
    )
  }
  
  // ✅ NEW: Get homepage cascasinos (where homepage: true)
  getHomepageCascasinos() {
    return api.get('cascasino/homepage')
  }

  /** Featured hub games for casino-first-strip tiles (`/casino-hub/:slug`). */
  getHubCasinoGames(slug: string) {
    return api.get(`cascasino/hub/${encodeURIComponent(slug)}`)
  }
  getIntCasinoList(provider:any, type:any) {
    return api.get(`get-casino-int-games?provider=${provider}&type=${type}`)
  }

  getplaycasino(data:any) {
    return api.post(`get-cas-casino-play-url`, data)
  }

  getCasinoDataById(id: any) {
    return api.get(`get-casino-data-by-id/${id}`)
  }

  getLiveCasinoData(slug: any) {
    return api.get(`casino/legacy-market/${slug}`)
  }

  getResultByMid(type: string, mid: string) {
    return api.get(
      `html-cards/${type}/${mid}/?ismobile=${isMobile}`,
    )
  }

  getResultList(filterdata: { matchid: string; startDate: string; roundId: string }, page: number) {
    return api.get(
      `done-results/${filterdata.matchid}?filter_date=${filterdata.startDate}&roundId=${filterdata.roundId}&page=${page}`,
    )
  }

  disableCasino(matchId: string) {
    return api.post('disable-casino-games', { slug: matchId, matchId })
  }

  setCasinoStatus(slug: string, isDisable: boolean) {
    return api.post('disable-casino-games', { slug, isDisable })
  }

  getDisabledCasinoTypes() {
    return api.get('casino/disabled')
  }

  // ═══════════════════════════════════════════════════════
  // CASCASINO (HUIDU INTERNATIONAL CASINO) METHODS
  // ═══════════════════════════════════════════════════════

  /**
   * Get cascasino games list
   */
  getCascasinoGames(type?: string, provider?: string, category?: string) {
    const params = new URLSearchParams();
    if (type) params.append('type', type);
    if (provider) params.append('provider', provider);
    if (category) params.append('category', category);
    return api.get(`cascasino/games?${params.toString()}`);
  }

  /**
   * Get cascasino providers
   */
  getCascasinoProviders(type?: string) {
    const params = type ? `?type=${type}` : '';
    return api.get(`cascasino/providers${params}`);
  }

  /**
   * Get cascasino categories
   */
  getCascasinoCategories(type?: string, provider?: string) {
    const params = new URLSearchParams();
    if (type) params.append('type', type);
    if (provider) params.append('provider', provider);
    return api.get(`cascasino/categories?${params.toString()}`);
  }

  /**
   * Get cascasino game details
   */
  getCascasinoGameDetails(gameIdentifier: string) {
    return api.get(`cascasino/game/${gameIdentifier}`);
  }

  /**
   * Launch cascasino game
   */
  launchCascasinoGame(gameIdentifier: string) {
    return api.post(`cascasino/launch`, { gameIdentifier });
  }

  /**
   * Get cascasino bet history
   */
  getCascasinoBetHistory(page?: number, limit?: number, status?: string) {
    const params = new URLSearchParams();
    if (page) params.append('page', page.toString());
    if (limit) params.append('limit', limit.toString());
    if (status) params.append('status', status);
    return api.get(`cascasino/bet-history?${params.toString()}`);
  }

  /**
   * Get cascasino statistics
   */
  getCascasinoStats() {
    return api.get(`cascasino/stats`);
  }
}
export default new CasinoService()
